module.exports = __webpack_public_path__ + "img/countries.87cd37c6.svg";